/* HK footer (hk-coolfooter section): contact form validation, spam traps, rate limit, stuck-submit
   watchdog, outcome detection and click-to-load map. Each .hk-foot root reads its section id, design
   mode and messages from <script type="application/json" id="hk-foot-cfg-<section id>">. Without this
   script the form still submits natively (progressive enhancement). */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__hkfInit) return;
    var cfgEl = document.getElementById(root.id.replace('hk-foot-', 'hk-foot-cfg-'));
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.__hkfInit = true;

    var SID = cfg.sid;
    var DESIGN = !!cfg.design;
    var M = cfg.messages;

    /* ── 2. Contact form ───────────────────────────────────────────── */
    var form = root.querySelector('form.hkf-form');
    var card = root.querySelector('.hkf__card');
    if (form && card) {
      form.noValidate = true; /* custom, localised validation replaces browser bubbles */

      var btn      = form.querySelector('.hkf__btn');
      var errBar   = form.querySelector('.hkf__err-bar');
      var rateBar  = form.querySelector('.hkf__rate-bar');
      var hp       = form.querySelector('[name="hkf_hp"]');
      var msg      = form.querySelector('[data-hkv="message"]');
      var ctr      = form.querySelector('.hkff__count');
      var success  = card.querySelector('.hkf__success');
      var okTitle  = card.querySelector('.hkf__ok-title');
      var cardTitle= card.querySelector('.hkf__card-title');
      var t0       = Date.now();
      var TRAP_MS  = 3000;     /* faster than any human can fill the form */
      var RL_KEY   = 'hk_fc_' + SID;
      var RL_MS    = 60000;

      /* Characters a name can't contain, for the as-you-type filter: Romanian (ș/ş, ț/ţ), Gagauz
         (ü, ö, ç, ğ, ı), Cyrillic, any Latin script pass; digits/symbols are dropped. */
      var NAME_BAD, NAME_BAD_G;
      try {
        NAME_BAD   = new RegExp("[^\\p{L}\\p{M}\\s'’.\\-]", 'u');
        NAME_BAD_G = new RegExp("[^\\p{L}\\p{M}\\s'’.\\-]", 'gu');
      } catch (e) {
        NAME_BAD   = /[0-9_@#$%^&*=+<>|\\\/:;"!?,~`]/;
        NAME_BAD_G = /[0-9_@#$%^&*=+<>|\\\/:;"!?,~`]/g;
      }
      var PHONE_BAD   = /[^\d+\s()\-]/;
      var PHONE_BAD_G = /[^\d+\s()\-]/g;

      function cleanPhone(v) {
        var lead = /^\s*\+/.test(v);
        v = v.replace(PHONE_BAD_G, '').replace(/\+/g, '');
        return lead ? '+' + v.replace(/^\s+/, '') : v;
      }
      /* Pretty-print Moldovan numbers on blur; anything else is left as typed */
      function fmtPhone(v) {
        var compact = v.replace(/[\s()\-]/g, '');
        var d = compact.replace(/\D/g, '');
        if (/^\+?373\d{8}$/.test(compact)) return '+373 ' + d.slice(3, 5) + ' ' + d.slice(5, 8) + ' ' + d.slice(8);
        if (/^0\d{8}$/.test(compact))      return d.slice(0, 3) + ' ' + d.slice(3, 6) + ' ' + d.slice(6);
        return v.trim().replace(/\s+/g, ' ');
      }

      /* name / e-mail / phone: the shared lead-form rules (assets/hk-validate.js, ARCH-023);
         the messages stay this section's own settings */
      var RULES = {
        name: function (v) {
          v = v.trim();
          if (!v) return M.nameReq;
          if (!window.HKValidate.name(v)) return M.nameShort;
          return '';
        },
        email: function (v) {
          v = v.trim();
          if (!v) return M.emailReq;
          if (!window.HKValidate.email(v)) return M.emailBad;
          return '';
        },
        phone: function (v) {
          if (!v.trim()) return M.phoneReq;
          if (!window.HKValidate.phone(v).ok) return M.phoneBad;
          return '';
        },
        message: function (v) {
          v = v.trim();
          if (!v) return M.msgReq;
          if (v.length < 10) return M.msgShort;
          return '';
        }
      };

      function check(inp) {
        var type = inp.getAttribute('data-hkv');
        var wrap = inp.closest('.hkff');
        var errEl = wrap.querySelector('.hkff__err');
        var err = type === 'consent' ? (inp.checked ? '' : M.consent) : RULES[type](inp.value);
        wrap.classList.toggle('invalid', !!err);
        wrap.classList.toggle('valid', !err && type !== 'consent' && !!inp.value.trim());
        if (err) inp.setAttribute('aria-invalid', 'true'); else inp.removeAttribute('aria-invalid');
        if (errEl) errEl.textContent = err;
        return !err;
      }

      function updateCount() {
        if (!msg || !ctr) return;
        var l = msg.value.length, mx = msg.maxLength > 0 ? msg.maxLength : 500;
        ctr.textContent = l + '/' + mx;
        ctr.classList.toggle('warn', l > mx * 0.88);
      }

      function sanitize(inp) {
        var t = inp.getAttribute('data-hkv'), c;
        if (t === 'name')  { c = inp.value.replace(NAME_BAD_G, ''); if (c !== inp.value) inp.value = c; }
        if (t === 'phone') { c = cleanPhone(inp.value);             if (c !== inp.value) inp.value = c; }
      }

      form.querySelectorAll('[data-hkv]').forEach(function (inp) {
        var type = inp.getAttribute('data-hkv');

        if (type === 'consent') {
          inp.addEventListener('change', function () { check(inp); });
          return;
        }

        /* Block bad keystrokes early — but never during IME composition */
        inp.addEventListener('beforeinput', function (e) {
          if (e.isComposing || !e.data) return;
          if (type === 'name'  && NAME_BAD.test(e.data))  e.preventDefault();
          if (type === 'phone' && PHONE_BAD.test(e.data)) e.preventDefault();
        });

        /* Clean pastes/autofill; re-check only once the field has a state
           ("reward early, punish late" — no errors while first typing) */
        inp.addEventListener('input', function (e) {
          if (e.isComposing) return;
          sanitize(inp);
          if (type === 'message') updateCount();
          var w = inp.closest('.hkff');
          if (w.classList.contains('invalid') || w.classList.contains('valid')) check(inp);
        });
        inp.addEventListener('compositionend', function () { sanitize(inp); });

        inp.addEventListener('blur', function () {
          if (!inp.value.trim()) return;
          if (type === 'phone') inp.value = fmtPhone(inp.value);
          check(inp);
        });
      });
      updateCount();

      /* Rate limit (soft, client-side) */
      var rateTimer;
      function getLast() { try { return parseInt(localStorage.getItem(RL_KEY), 10) || 0; } catch (e) { return 0; } }
      function setLast() { try { localStorage.setItem(RL_KEY, String(Date.now())); } catch (e) {} }
      function clearLast() { try { localStorage.removeItem(RL_KEY); } catch (e) {} }
      function showRate(sec) {
        clearInterval(rateTimer);
        var paint = function () { rateBar.textContent = M.rate.replace('%s', sec); };
        paint();
        rateBar.hidden = false;
        rateTimer = setInterval(function () {
          sec -= 1;
          if (sec <= 0) { clearInterval(rateTimer); rateBar.hidden = true; return; }
          paint();
        }, 1000);
      }

      function setLoading(on) {
        btn.classList.toggle('loading', on);
        btn.disabled = on;
        if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
      }

      /* Success overlay */
      var hideTimer;
      function showOK(focus) {
        if (!success) return;
        success.classList.add('active');
        setTimeout(function () {
          form.reset();
          form.querySelectorAll('.hkff').forEach(function (w) { w.classList.remove('valid', 'invalid'); });
          form.querySelectorAll('[aria-invalid]').forEach(function (i) { i.removeAttribute('aria-invalid'); });
          form.querySelectorAll('.hkff__err').forEach(function (e) { e.textContent = ''; });
          errBar.hidden = true;
          updateCount();
        }, 450);
        if (focus && okTitle) { try { okTitle.focus({ preventScroll: true }); } catch (e) { okTitle.focus(); } }
        clearTimeout(hideTimer);
        if (!DESIGN) hideTimer = setTimeout(hideOK, 8000);
      }
      function hideOK() {
        var hadFocus = success.contains(document.activeElement);
        success.classList.remove('active');
        if (hadFocus && cardTitle) { try { cardTitle.focus({ preventScroll: true }); } catch (e) {} }
      }

      form.addEventListener('submit', function (e) {
        /* Spam traps: hidden field filled, or submitted inhumanly fast.
           Pretend it worked so the bot learns nothing. */
        if ((hp && hp.value) || Date.now() - t0 < TRAP_MS) {
          e.preventDefault();
          showOK(false);
          return;
        }

        var wait = Math.ceil((RL_MS - (Date.now() - getLast())) / 1000);
        if (wait > 0) {
          e.preventDefault();
          showRate(wait);
          return;
        }

        var firstBad = null;
        form.querySelectorAll('[data-hkv]').forEach(function (inp) {
          if (!check(inp) && !firstBad) firstBad = inp;
        });
        if (firstBad) {
          e.preventDefault();
          errBar.textContent = M.general;
          errBar.hidden = false;
          errBar.style.animation = 'none'; void errBar.offsetWidth; errBar.style.animation = '';
          firstBad.focus({ preventScroll: true });
          firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        errBar.hidden = true;
        rateBar.hidden = true;
        if (stuckBar) stuckBar.hidden = true;
        setLoading(true);
        setLast();
        submitAt = Date.now();
        clearTimeout(stuckTimer);
        stuckTimer = setTimeout(unstick, STUCK_MS);
        /* native POST continues → Shopify redirects back to return_to */
      });

      /* Watchdog: Shopify's hCaptcha only navigates when its challenge passes. Still here after
         STUCK_MS (challenge closed / failed to load) → give the button back, values kept, and show
         the phone / WhatsApp line. */
      var STUCK_MS = 12000, stuckTimer, submitAt = 0;
      var stuckBar = form.querySelector('[data-hk-stuck]');
      function unstick() {
        if (!btn.disabled || document.visibilityState !== 'visible') return;
        setLoading(false);
        clearLast();
        if (stuckBar) stuckBar.hidden = false;
      }
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible' && btn.disabled && submitAt && Date.now() - submitAt > STUCK_MS) unstick();
      });

      /* Back/forward cache: un-stick the button */
      window.addEventListener('pageshow', function (e) { if (e.persisted) setLoading(false); });

      /* Outcome detection after the round-trip */
      var params;
      try { params = new URLSearchParams(location.search); } catch (e) { params = null; }
      var sentHere = !!params && params.get('hkf_sent') === SID;
      var hashOurs = location.hash === '#' + form.id || location.hash === '#' + root.id;
      var hashNone = !location.hash;
      var postedAny = !!form.querySelector('[data-hkf-posted]');
      var errorsAny = !!form.querySelector('[data-hkf-errors]');

      if (sentHere || (postedAny && (hashOurs || hashNone))) {
        showOK(true);
      }

      if (errorsAny) {
        if (hashOurs || hashNone) {
          clearLast(); /* let them retry immediately after fixing */
          if (hashOurs) card.scrollIntoView({ block: 'center' });
        } else {
          /* errors belong to another contact form on this page */
          errBar.hidden = true;
          form.querySelectorAll('.hkff.invalid').forEach(function (w) { w.classList.remove('invalid'); });
        }
      }

      /* Clean the URL so a refresh doesn't replay the success message */
      if (params) {
        var dirty = false;
        if (params.has('hkf_sent')) { params.delete('hkf_sent'); dirty = true; }
        if ((sentHere || (postedAny && hashOurs)) && params.has('contact_posted')) { params.delete('contact_posted'); dirty = true; }
        if (dirty) {
          var qs = params.toString();
          try { history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) {}
        }
      }
    }

    /* ── 3. Click-to-load maps (no Google request until asked) ─────── */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.hkf-bot__map-facade');
      if (!b || !root.contains(b)) return;
      var src = b.getAttribute('data-hkf-map') || '';
      if (!/^https:\/\/((www|maps)\.)?google\.[a-z.]+\/maps/i.test(src)) return;
      var f = document.createElement('iframe');
      f.src = src;
      f.title = b.getAttribute('data-hkf-map-title') || '';
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      var box = b.parentNode;
      b.replaceWith(f);
      box.classList.add('is-loaded');
      f.focus();
    });
  }

  function initAll(scope) { (scope || document).querySelectorAll('.hk-foot').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
